<template>
    <div class="fixed-center full-width">
        <div v-if="!isLoggedIn">
            <div v-if="!showPassRecovery" class="row justify-center">
                <login :autoActivationMode="true"
                       @forgot="showPassRecovery = true"
                       @loggedIn="retrieveActivation" />
            </div>
            <div v-else>
                <forgot-pass :autoActivationMode="true"
                             @back="showPassRecovery = false"
                             @login="showPassRecovery = false" />
            </div>
        </div>
        <div v-else-if="invalid" class="row justify-center">
            <q-card style="max-width: 375px">
                <q-card-section class="bg-primary text-white">
                    <div class="text-h6 row items-center">
                        <q-icon name="mdi-card-text" size="sm" class="q-mr-xs" />No Valid License Was Found
                    </div>
                </q-card-section>
                <q-card-section>
                    We could not find a valid license from your account to activate, please purchase a valid license. For further assistance please contact support or call 403.247.8566.
                </q-card-section>
            </q-card>
        </div>
        <dialog-activate :show.sync="showDialogActivate"
                         :activation.sync="currentActivation"
                         :license.sync="currentLicense"
                         :isAutoActivation="true"
                         :installId="$route.query.InstallID"
                         @back="goBack"
                         @generated="codeGenerated" />
        <dialog-activations :show.sync="showDialogActivations"
                            :license="currentLicense"
                            :isAutoActivation="true"
                            @activate="activateLicense"
                            @replace="replaceActivation" />

        <q-dialog v-model="showDialogMaxActivationsExceeded" persistent>
            <q-card style="max-width: 450px;" class="full-width">
                <q-card-section>
                    <div class="text-h6 row items-center text-negative">
                        <q-icon name="mdi-cancel" size="sm" class="q-mr-xs" />Max Activations Exceeded
                    </div>
                </q-card-section>
                <q-card-section class="q-pt-none">
                    Sorry, you have exceeded the maximum number of replacement activations allowed at this moment. For further assistance please contact support or call 403.247.8566.
                </q-card-section>
                <q-card-section class="q-pt-none">
                    <div>
                        <q-btn label="Close" color="primary" v-close-popup />
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-inner-loading :showing="getAutoActivationPending || getAlternateActivationPending">
            <div>
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
        </q-inner-loading>
    </div>
</template>
<script>
    import login from '@/components/Login'
    import forgotPass from '@/components/ForgotPass'
    import { mapState } from 'vuex'
    import dialogActivate from '@/components/dialogs/DialogActivate'
    import dialogActivations from '@/components/dialogs/DialogActivations'

    export default {
        name: 'auto-activation',
        components: {
            login,
            forgotPass,
            dialogActivate,
            dialogActivations,
        },
        data() {
            this.baseUrl = process.env.VUE_APP_BASEURL
            return {
                currentLicense: null,
                currentActivation: null,
                showDialogActivate: false,
                showDialogActivations: false,
                showDialogMaxActivationsExceeded: false,
                invalid: false,
                showPassRecovery: false,
            }
        },
        methods: {
            goBack() {
                this.currentActivation = null
                this.showDialogActivate = false
                this.showDialogActivations = true
            },
            replaceActivation(activation) {
                this.currentActivation = activation
                this.$store.dispatch('getLicense', this.currentActivation.licenseID).then(() => {
                    this.currentLicense = this.getLicenseData
                    this.$store.dispatch('isMaxActivationsExceeded', this.currentLicense).then(() => {
                        if (this.isMaxActivationsExceededData)
                            this.showDialogMaxActivationsExceeded = true
                        else
                            this.showDialogActivate = true
                    })
                })
            },
            activateLicense(license) {
                this.currentLicense = license
                this.currentActivation = null
                this.showDialogActivate = true
            },
            codeGenerated(payload) {
                const url = `?ActivationProcessed=true&ActivationCode=${payload.activation.activationCode}`
                this.redirectUrl(url)
                return
            },
            redirectUrl(url) {
                if (url) {
                    window.location.replace(this.baseUrl + 'autoactivation' + url)
                }
                this.$store.dispatch('logout')
            },
            retrieveActivation() {
                this.$store.dispatch('getActivationCode', this.$route.query).then(() => {
                    let url = '?PageType=Invalid'
                    if (this.getAutoActivationData) {
                        // Activation code found
                        url = `?ActivationProcessed=true&ActivationCode=${this.getAutoActivationData}`
                        this.redirectUrl(url)
                        return
                    }

                    // No activation code found, attempt alternative activation route
                    this.$store.dispatch('getAlternateActivation', this.$route.query).then(() => {
                        if (!this.getAlternateActivationData) {
                            // Activation code not found
                            url = '?PageType=Invalid'
                            this.redirectUrl(url)
                            return
                        }

                        if (this.getAlternateActivationData?.status && this.getAlternateActivationData?.license) {
                            this.currentLicense = this.getAlternateActivationData.license

                            if (this.getAlternateActivationData.status == 'UpdateVersion') {
                                let activation = this.currentLicense.activations.find(a => a.installID == this.$route.query?.InstallID)
                                if (activation && activation?.activationCode) url = `?ActivationProcessed=true&ActivationCode=${activation.activationCode}`
                                this.redirectUrl(url)
                                return
                            }
                            if (this.getAlternateActivationData.status == 'Activate') {
                                if (this.currentLicense.activations.filter(a => a.isCurrent).length == 0)
                                    this.showDialogActivate = true
                                else
                                    this.showDialogActivations = true
                                return
                            }
                        }
                        this.redirectUrl(url)
                        return
                    })
                })
            },
        },
        computed: {
            ...mapState([
                'infoFromSoftware',
                'getAutoActivationData',
                'getAutoActivationPending',
                'getAlternateActivationData',
                'getAlternateActivationPending',
                'getLicenseData',
                'getLicensePending'
            ]),
            screenSize() {
                return this.$q.screen
            },
            isLoggedIn() { return this.$store.getters.isLoggedIn },
        },
        created() {
            if (this.$route.query) {
                this.$store.commit('update_inforFromSoftware', this.$route.query)
            }

            if (this.$route.query?.PageType == 'Invalid') {
                this.invalid = true
                return
            }

            if (this.$route.query?.ActivationProcessed) {
                this.invalid = false
                return
            }

            this.showPassRecovery = false
            if (this.isLoggedIn) this.retrieveActivation()
        },
        watch: {
            isLoggedIn(newVal) {
                if (newVal) {
                    this.retrieveActivation()
                }
            },
        }

    }
</script>
